import { useState } from 'react'
import type { ShownInSplitView, SplitViewSelection } from './settingEditor.types'

type SplitViewHighlight = {
  shown: SplitViewSelection | null
  highlighted: SplitViewSelection | null
  /** Give to the split view, which says what it shows as the user moves around in it. */
  onShownChange: (shownInSplitView: ShownInSplitView) => void
}

/**
 * The main view highlights what the split view shows: what it was opened for, until the split view
 * reports that it shows something else (another setting from its own list, or the setting a save
 * stored). A report for an earlier selection is ignored, so a new click is highlighted at once.
 */
export function useSplitViewHighlight(
  selection: SplitViewSelection | null,
  selectionRevision: number
): SplitViewHighlight {
  const [shownInSplitView, setShownInSplitView] = useState<ShownInSplitView | null>(null)
  const isCurrent = shownInSplitView?.selectionRevision === selectionRevision

  return {
    shown: selection && isCurrent ? shownInSplitView.shown : selection,
    highlighted: selection && isCurrent ? shownInSplitView.highlighted : selection,
    onShownChange: setShownInSplitView,
  }
}
